import React from 'react'
import { Title, H, Represented, StateRepresented } from '../utils.tsx';

import * as settings from '../settings.js'
import { PartyCircles } from './partycircles'

export const PartyRepresentationText = ({ 
  data,
  userData
}: {
  data: Array<any>,
  userData: any
}) => {

  let representedText: string
  let representationClass: StateRepresented;
  let partyNotInList: boolean = false

  if(userData.party in data.party)
  {
    const e = data.party[userData.party].board
    const i = data.party[userData.party]['2019']  
    const toleranceMin = 5
    const toleranceMax = 15

    // Get Representation Class
    if(Math.abs(e - i) <= toleranceMin) representationClass = StateRepresented.good
    else if((e - i) > toleranceMax) representationClass = StateRepresented.stronglyOver
    else if((e - i) > toleranceMin) representationClass = StateRepresented.slightlyOver
    else if((i - e) > toleranceMax) representationClass = StateRepresented.stronglyUnder
    else if((i - e) > toleranceMin) representationClass = StateRepresented.slightlyUnder

  }
  else
  {
    representationClass = StateRepresented.good
    partyNotInList = true
  }

  // Get Representation Text
  if(representationClass == StateRepresented.good) representedText = 'angemessen vertreten'
  else if(representationClass == StateRepresented.stronglyOver) representedText = 'stark übervertreten'
  else if(representationClass == StateRepresented.slightlyOver) representedText = 'übervertreten'
  else if(representationClass == StateRepresented.stronglyUnder) representedText = 'stark untervertreten'
  else if(representationClass == StateRepresented.slightlyUnder) representedText = 'untervertreten'    

  const domTextFromPartyList = (parties: any) => {
    // Group Party Is
    const partyIsGrouped = parties.reduce((acc, cur) => {
      acc[cur] = acc[cur] + 1 || 1
      return acc
    }, {})

    // Build Doms  
    return Object.keys(partyIsGrouped).map((e, i) => {
      return (<span key={i}>
        <span 
          style={{color: settings.partyColor[e]}}
        >{e === 'parteilos' ? 'parteilose' : settings.partyCleaned[e]}
        </span>
        {' '}({partyIsGrouped[e]}
        {i === 0 ? partyIsGrouped[e] === 1 ? ' Sitz' : ' Sitze' : ''})
        {i < Object.keys(partyIsGrouped).length - 2 ? ', ' : i == Object.keys(partyIsGrouped).length -2 ? ' und ' : ''}
      </span>)
    })
  }

  return (
    <div className='userText'>

      <Title>Partei</Title>

      {userData.party != '' &&
        <>
          <Represented state={representationClass}/>
          <p>
            Politisch sind Sie {representedText}.{' '}
            {partyNotInList === false && 
              <>
                Die <H>
                  {settings.partyInText[userData.party]}{' '}
                  {['parteilos', 'grüne'].includes(userData.party) ? 'halten' : 'hält'}
                  {' '}{data.party[userData.party].board === 0 ? 'keinen' : <>{data.party[userData.party].board} Prozent</>}
                </H>{' '}
                der Sitze in der Exekutive. In den{' '}
                <H>
                  Kantonsratswahlen von 2019 hat diese Partei {representationClass != StateRepresented.good ? 'jedoch ' : ''}{' '}
                  {data.party[userData.party]['2019'] === 0 ? 'keine Stimmen' : <>{data.party[userData.party]['2019']} Prozent der Stimmen</>}
                  {' '}aus {data.name} erhalten.
                </H>
              </>
            }
            {partyNotInList && 
              <>
                In {data.name}{' '}
                {['parteilos', 'grüne'].includes(userData.party) ? 'sind' : 'ist'}
                {' '}<H>die {settings.partyInText[userData.party]} in der Exekutive{' '}
                zwar nicht verteten</H>, diese Partei hat jedoch in den letzten Kantonsratswahlen auch kein{' '}
                nennenswertes Ergebnis erziehlt.
              </>
            }
          </p>
        </>
      }
      
      Die Wahl der Exekutive ist allerdings eine Personenwahl, gewählt wird nicht eine Partei, sondern{' '}
      eine Kandidatin oder ein Kandidat. <H>Der {settings.executive[data.type].noun} repräsentiert darum{' '}
      oft nicht die Stärke der Lokalparteien.</H> In {data.name} zum Beispiel regieren {domTextFromPartyList(data.executiveparty.is)}.
      <PartyCircles 
        data = {data.executiveparty.is}
      />
      
      <p>
        Angenommen, Parteien sollten im Gemeinde- oder Stadtrat gemäss ihrem Wahlergebnis der letzten Kantonsratswahlen{' '} 
        vertreten sein, so müsste sich die Exekutive in {data.name} wie folgt zusammensetzen:
      </p>
      
      <PartyCircles 
        data = {data.executiveparty.should}
      />
      Sitze erhielten {domTextFromPartyList(data.executiveparty.should)}. Folgende Grafik zeigt,{' '}
      wie die Sitzverteilung pro Partei von der eigentlichen Parteistärke abweicht.


      


    </div>
  )
}
